import { MediumTitle, Modal, palettes, SmallBody } from '@indigo-ag/component-module';
import React from 'react';
import styled from 'styled-components';
import i18next from 'i18next';
import { currency, GridContainer, GridContainerItem } from 'shared';
import { BacenItem } from '../../../../phases/Phase1.utils';

const DetailModal = styled(Modal)`
  max-width: 680px;
  padding-bottom: 16px;
  overflow: scroll;
  max-height: 600px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const FailureReasonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  report: BacenItem;
}

const getInfoItems = (report: BacenItem): GridContainerItem[] => [
  {
    label: i18next.t('bacenDetailModal-fullResponsibilityValue'),
    value: currency.formatBrazilCurrency(report.fullResponsibilityValue)
  },
  {
    label: i18next.t('bacenDetailModal-overdueValue'),
    value: currency.formatBrazilCurrency(report.overdueValue)
  },
  {
    label: i18next.t('bacenDetailModal-financialLossValue'),
    value: currency.formatBrazilCurrency(report.financialLossValue)
  },
  {
    label: i18next.t('bacenDetailModal-debtPercentage'),
    value: `${report.percentageOfDebts}%`
  }
];

const getFailureReasons = (report: BacenItem): GridContainerItem[] =>
  report.reasons.map<GridContainerItem>(reason => ({
    customField: (
      <SmallBody style={{ color: palettes.brand.red.dark, borderBottom: `1px solid ${palettes.brand.red.dark}40` }}>
        {reason}
      </SmallBody>
    )
  }));

export const BacenRestrictionsDetailModal = ({ isOpen, onRequestClose, report }: Props) => {
  const hasFailureReasons = report.reasons.length > 0 && report.status === 'UNRESOLVED';

  const content = (
    <>
      {!hasFailureReasons && <GridContainer columns={2} items={getInfoItems(report)} />}
      {hasFailureReasons && (
        <FailureReasonsContainer>
          <MediumTitle style={{ color: palettes.brand.blue.base }}>
            {i18next.t('bacenDetailModal-failureReasons')}
          </MediumTitle>
          <GridContainer columns={1} items={getFailureReasons(report)} />
        </FailureReasonsContainer>
      )}
    </>
  );

  return (
    <DetailModal
      onRequestClose={onRequestClose}
      renderContent={() => content}
      open={isOpen}
      title={i18next.t('bacenRestrictionsDetailModal_title')}
    />
  );
};
